import React from 'react';

const ErrorMessage = ({ 
  message, 
  type = 'error', 
  onClose, 
  show = true,
  className = '' 
}) => {
  if (!show || !message) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '❌';
    }
  };

  const getStyles = () => {
    switch (type) {
      case 'success':
        return {
          background: '#d4edda',
          color: '#155724',
          border: '1px solid #c3e6cb',
          icon: '#809947'
        };
      case 'warning':
        return {
          background: '#fff3cd',
          color: '#856404',
          border: '1px solid #ffeaa7',
          icon: '#ffc107'
        };
      case 'info':
        return {
          background: '#d1ecf1',
          color: '#0c5460',
          border: '1px solid #bee5eb',
          icon: '#17a2b8'
        };
      default:
        return {
          background: '#f8d7da',
          color: '#721c24',
          border: '1px solid #f5c6cb',
          icon: '#dc3545'
        };
    }
  };

  const styles = getStyles();

  return (
    <div 
      className={`error-message ${type} ${className}`}
      style={{
        padding: '15px 20px',
        borderRadius: '8px',
        margin: '10px 0',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        background: styles.background,
        color: styles.color,
        border: styles.border,
        fontSize: '14px',
        fontWeight: '500',
        position: 'relative'
      }}
    >
      <span style={{ fontSize: '16px', color: styles.icon }}>
        {getIcon()}
      </span>
      <span style={{ flex: 1 }}>{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: 'inherit',
            fontSize: '18px',
            cursor: 'pointer',
            padding: '0',
            marginLeft: '10px',
            opacity: '0.7'
          }}
          onMouseOver={(e) => e.target.style.opacity = '1'}
          onMouseOut={(e) => e.target.style.opacity = '0.7'}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;








